// extracted by mini-css-extract-plugin
module.exports = {"body":"IframeVideo_body__2LdiM"};